import React from "react";
import { INK, INK_2, INK_3 } from "../../Bureau/bureauTokens";

function rgba(hex, a) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
}

// .pl-ev — bloc de RDV (Google Calendar) positionné en absolu dans une
// colonne jour (top/height calculés par l'organisme parent selon l'heure/la
// durée). Pas de glisser-déposer ni d'étirement (voir plan Planning) — juste
// l'ouverture au clic.
function RdvBlock({ top, height, time, canal, client, motif, collabInitials, color, onClick }) {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="absolute text-left overflow-hidden flex flex-col"
      style={{
        left: 4,
        right: 4,
        top,
        height,
        gap: 1,
        borderRadius: 9,
        borderLeft: `3px solid ${color}`,
        padding: "4px 7px",
        boxShadow: "0 1px 3px rgba(0,0,0,.10)",
        background: `linear-gradient(180deg, #fff, ${rgba(color, 0.14)})`,
        zIndex: 2,
      }}
    >
      <span className="flex items-center gap-1 text-[9.5px] font-bold" style={{ color: INK_2 }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: color, flexShrink: 0 }} />
        {time} · {canal}
      </span>
      <span className="truncate text-[11px] font-bold" style={{ color: INK }}>
        {client}
      </span>
      <span className="truncate text-[10px]" style={{ color: INK_3 }}>
        {motif}
      </span>
      <span
        className="absolute flex items-center justify-center text-white font-bold"
        style={{ top: 5, right: 6, width: 15, height: 15, borderRadius: "50%", background: color, fontSize: 7.5, boxShadow: "0 0 0 2px #fff" }}
      >
        {collabInitials}
      </span>
    </button>
  );
}

export default RdvBlock;
